import { useSelector } from "react-redux";
import { RootState } from "../../../../store/store";
import TagView from "./TagView";
import { Link } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import { Button, Modal } from "react-bootstrap";
import { useEffect, useState } from "react";
import AccountTag from "../../model/AccountTag";
import tagsApi from "../../api/TagsApi";
import { updateAccountTagsStore } from "../../../../store/functions";

const TagsControl = () => {
    const accountTags = useSelector((state: RootState) => state.app.accountTags);

    const [showTagsListModal, setShowTagsListModal] = useState<boolean>(false);
    const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState<boolean>(false);
    const [accountTagForDelete, setAccountTagForDelete] = useState<AccountTag|null>(null);
    const [accountTagForEdit, setAccountTagForEdit] = useState<AccountTag|null>(null);

    useEffect(() => {
        if (accountTagForDelete !== null) {
            setShowDeleteConfirmModal(true)
        } else {
            setShowDeleteConfirmModal(false)
        }

    }, [accountTagForDelete]);

    useEffect(() => {
        if (accountTagForEdit !== null) {
            setShowDeleteConfirmModal(true)
        } else {
            setShowDeleteConfirmModal(false)
        }

    }, [accountTagForEdit]);

    const deleteAccountTag = (accountTag: AccountTag|null) => {
        if (accountTag == null) return;
        tagsApi.deleteAccountTag(accountTag)
            .then(() => {
                updateAccountTagsStore();
                setAccountTagForDelete(null);
            })
    }

    const DeleteConfirmModal = () => {
        return (
            <Modal show={showDeleteConfirmModal} onHide={() => setAccountTagForDelete(null)}>
                <Modal.Body>
                    <p><FormattedMessage id="delete"/></p>
                </Modal.Body>
                    <div className="text-center">
                        {null != accountTagForDelete ? <TagView accountTag={accountTagForDelete!}/> : ""}
                    </div>                    
                <Modal.Footer>
                <Button variant="secondary" onClick={(e) => setAccountTagForDelete(null)}>
                    <FormattedMessage id="cancel"/>
                </Button>
                <Button variant="primary" className="btn btn-color"
                        onClick={(e) => deleteAccountTag(accountTagForDelete)}>
                    <FormattedMessage id="delete"/>
                </Button>
                </Modal.Footer>
            </Modal>
        )
    }

    const TagsListModal = () => {
        return (
            <Modal show={showTagsListModal} onHide={() => setShowTagsListModal(false)}>
                <Modal.Header closeButton>
                  <Modal.Title>
                    <FormattedMessage id="tags_management"/>
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <TagsList/>
                </Modal.Body>
              </Modal>
        )
    }

    const TagsList = () => {
        return (
            <div className="tags-control-list">
                {accountTags.map(accountTag => {
                    return <div key={'tags-control-item' + accountTag.tagId} className="tags-control-item">
                        <TagView key={'tags-menu-account-tag' + accountTag.tagId} accountTag={accountTag}/>
                        <div>
                            {/* <Button type="button" className="btn btn-color btn-edit">
                                <i className="fa-regular fa-pen-to-square"></i>
                            </Button> */}
                            <Button type="button" className="btn btn-color btn-delete"
                                     onClick={(e) => setAccountTagForDelete(accountTag)}>
                                <i className="fa-regular fa-trash-can"></i>
                            </Button>
                        </div>
                    </div>
                })}            
            </div>
        )
    }

    return (
        <>
            <div className="tags-control">
                <span onClick={(e) => setShowTagsListModal(true)}>
                    <FormattedMessage id="management"/>
                </span>
                <TagsListModal/>
            </div>
            <DeleteConfirmModal/>
        </>
    )
}
export default TagsControl